<template>
  <nav
    class="sidebar sidebar-offcanvas"
    v-bind:class="{ active: auth_store.hideMenu }"
    id="sidebar"
  >
    <ul class="nav">
      <li class="nav-item">
        <RouterLink class="nav-link" to="/dashboard">
          <span class="menu-title">Dashboard</span>
          <i class="mdi mdi-home menu-icon"></i>
        </RouterLink>
      </li>
      <li class="nav-item">
        <RouterLink class="nav-link" to="/released-product">
          <span class="menu-title">Released Products</span>
          <i class="mdi mdi mdi-amplifier menu-icon"></i>
        </RouterLink>
      </li>
      <!-- <li class="nav-item">
        <RouterLink class="nav-link" to="/products">
          <span class="menu-title">Products</span>
          <i class="mdi mdi mdi-amplifier menu-icon"></i>
        </RouterLink>
      </li> -->
      <li
        class="nav-item"
        v-if="user != null && user.usr_role.url_role_code == 'ADM'"
      >
        <RouterLink class="nav-link" to="/user-management">
          <span class="menu-title">User Management</span>
          <i class="mdi mdi-account menu-icon"></i>
        </RouterLink>
      </li>
      <li
        class="nav-item"
        v-if="user != null && user.usr_role.url_role_code != 'VWR'"
      >
        <RouterLink class="nav-link" to="/product-certificates">
          <span class="menu-title">Product Certificates</span>
          <i class="mdi mdi-certificate menu-icon"></i>
        </RouterLink>
      </li>
    </ul>
  </nav>
</template>
<script setup>
import { useAuthStore } from "@/store/auth_store";
import { ref, onMounted } from "vue";

const auth_store = useAuthStore();
const user = ref(null);

onMounted(() => {
  user.value = auth_store.logged_in_user.user;
});
</script>
